<a class="block lg:px-6" routerLink="/dashboard">
    <svg class="block fill-light">
        <use xlink:href="assets/icons.svg#logo-r"></use>
    </svg>
</a>
